export default __webpack_public_path__ + "static/media/rightPattern.317a6bc9.svg";